import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { store } from './app/store.js';
import App from './App.jsx';
import './index.css';

// Import OM Design System styles
import '@om-design-system/web-components/dist/om-design-system-web/om-design-system-web.css';

// Register OM Design System custom elements
import { defineCustomElements } from '@om-design-system/web-components/loader';

// React instance logging

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // Data is fresh for 1 minute
      gcTime: 5 * 60 * 1000, // Keep cache for 5 minutes
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

// Function to render the React app
const renderApp = () => {
  const root = createRoot(document.getElementById('root'));
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <App />
        </Provider>
      </QueryClientProvider>
    </StrictMode>
  );
};

// Try to load Om Design System components with timeout fallback
const loadingTimeout = setTimeout(() => {
  renderApp();
}, 5000); // 5 second timeout

defineCustomElements(window)
  .then(() => {
    clearTimeout(loadingTimeout);
    renderApp();
  })
  .catch((error) => {
    clearTimeout(loadingTimeout);
    console.error('Failed to load Om Design System components:', error);
    // Render app anyway - components will render as unknown elements
    renderApp();
  });
